export const validEmail = (email:string) : boolean => {
    const i = email.replace(/\D+/g,'').length;
    return i > 6;
};
